import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'

import BkFlowNavigationProfileModalToggle from './BkFlowNavigationProfileModalToggle'
import BkFlowNavigationProfileMenuToggle from './BkFlowNavigationProfileMenuToggle'
import BkFlowNavigationAccorProfileMenu from './elements/BkFlowNavigationAccorProfileMenu'
import BkFlowNavigationCendynProfileMenu from './elements/BkFlowNavigationCendynProfileMenu'
import BkFlowMaterialLoader from '../../../elements/BkFlowMaterialLoader'

import { setProfileModalVisibility } from '../../../../actions/setProfile'
import fetchAccorProfileUser, { signOutProfileUser } from '../../../../actions/fetchAccorProfileUser'
import triggerCustomGaEvent from '../../../../utilities/analytics/triggerCustomGaEvent'
import yn from 'yn'

if (yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES)) {
	require('../../../../styles/css/components/navigation/bk-flow-navigation-profile.css')
}

class BkFlowNavigationProfile extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isProfileMenuVisible: true
		}
	}

	toggleProfileMenu() {
		this.setState({
			isProfileMenuVisible: !this.state.isProfileMenuVisible
		})

		const profileMenuData = {
			visible: !this.state.isProfileMenuVisible
		}

		triggerCustomGaEvent('analytics-profileMenuView', profileMenuData)
	}

	handleCloseProfileMenu = () => {
		this.setState({
			isProfileMenuVisible: false
		})

		const profileMenuData = {
			visible: false
		}

		triggerCustomGaEvent('analytics-profileMenuView', profileMenuData)
	}

	render() {
		const {
			// toggleProfileModal,
			configData,
			currentQuery,
			handleFetchProfileUser,
			handleSignOutProfileUser,
			isProfileAuthenticated,
			isUtilityNavVisible,
			profileUser,
			profileUserError,
			profileUserLoading,
			profileTokenLoading,
		} = this.props

		let loadingColor = '#000'

		if (yn(process.env.REACT_APP_COMPONENT_LANGUAGE_UTILITY_BAR)) {
			loadingColor = '#fff'
		}

		return  (
			<ClickAwayListener onClickAway={ () => this.handleCloseProfileMenu() }>
				<div className="bk-flow-navigation__profile">
					{ profileUserLoading || profileTokenLoading ?
						<BkFlowMaterialLoader
							parentClasses='u-txt-center'
							color={loadingColor}
							size={15}
						/>
					:	isProfileAuthenticated ?
						<Fragment>
							<BkFlowNavigationProfileMenuToggle
								toggleMenuEvent={() => this.toggleProfileMenu()}
								userFirstName={get(profileUser, 'firstName')}
								welcomeLabel={get(configData, 'hotel.labels[0].profileUserWelcomeMessage')}
							/>

							{ yn(process.env.REACT_APP_COMPONENT_NAVIGATION_UTILITY_BAR) &&
								process.env.REACT_APP_CRM_PROVIDER === 'accor' &&
								this.state.isProfileMenuVisible &&
								isUtilityNavVisible ?
									<BkFlowNavigationAccorProfileMenu
										configData={configData}
										profileUser={profileUser}
										profileUserError={profileUserError}
										closeMenuEvent={() => this.handleCloseProfileMenu()}
										handleFetchProfileUser={handleFetchProfileUser}
										handleSignOutProfileUser={handleSignOutProfileUser}
									/>
								: yn(process.env.REACT_APP_COMPONENT_NAVIGATION_UTILITY_BAR) &&
									process.env.REACT_APP_CRM_PROVIDER === 'cendyn' &&
									this.state.isProfileMenuVisible &&
									isUtilityNavVisible ?
										<BkFlowNavigationCendynProfileMenu
											configData={configData}
											profileUser={profileUser}
											profileUserError={profileUserError}
											closeMenuEvent={() => this.handleCloseProfileMenu()}
											handleFetchProfileUser={handleFetchProfileUser}
										/>
								:
									null
							}
						</Fragment>
					:
						<BkFlowNavigationProfileModalToggle
							configData={configData}
							currentQuery={currentQuery}
						/>
					}
				</div>
			</ClickAwayListener>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		currentQuery: state.availabilityData.currentQuery,
		isProfileAuthenticated: state.profileData.isProfileAuthenticated,
		profileUser: state.profileUserData.user,
		profileUserError: state.profileUserData.error,
		profileUserLoading: state.profileUserData.loading,
		profileTokenLoading: state.profileUserData.tokenLoading
	}
}

const mapDispatchToProps = (dispatch) => ({
	toggleProfileModal(profileModalVisibility) {
		return dispatch(setProfileModalVisibility(profileModalVisibility))
	},
	handleSignOutProfileUser() {
		return dispatch(signOutProfileUser())
	},
	handleFetchProfileUser() {
		return dispatch(fetchAccorProfileUser())
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowNavigationProfile)


// WEBPACK FOOTER //
// ./src/components/structure/navigation/profile/BkFlowNavigationProfile.js